
<div>
    <div><button (click)="logout()">Log out</button></div>
    <div>Emails:</div>
    <div>
        <p *ngFor="let e of sub | async">
            {{e}}
        </p>
    </div>
</div>